
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaitaxi() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Taxi',
        heading: 'Meghana Cab : Pune to Mumbai Taxi',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Taxi services, providing a smooth, safe, and comfortable journey between the two major cities. Whether you are traveling for business, leisure, or an airport drop, our well-maintained taxis and professional drivers ensure on-time pickups and a relaxed travel experience. Choose from a variety of vehicle options to suit your needs, and enjoy competitive rates, 24/7 customer support, and easy booking. Book your Pune to Mumbai Taxi with Meghana Cab for a reliable and stress-free ride.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "An iconic monument overlooking the Arabian Sea, the Gateway of India was built in 1924 to commemorate the visit of King George V. It is one of Mumbai’s most photographed landmarks and serves as the starting point for ferry rides to Elephanta Caves and Alibaug."
  },
  {
    "title": "Marine Drive",
    "description": "Also known as the Queen’s Necklace, this 3.6 km boulevard stretches along the Arabian Sea. It is popular for evening walks, sunset views, and the glittering skyline. The curved road lined with palm trees offers one of the best urban sea views in India."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, this historic railway station combines Victorian Gothic architecture with Indian influences. It is both a major transport hub and an architectural marvel with detailed carvings, stained glass, and a bustling atmosphere."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, a short ferry ride from Mumbai, these ancient rock-cut caves date back to the 5th–8th centuries. The caves feature sculptures and carvings dedicated to Lord Shiva, including the famous three-headed Maheshmurti."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant street market known for its eclectic shops, street food, art galleries, and colonial architecture. It's a great place for souvenir shopping and is surrounded by landmark cafes like Leopold and Café Mondegar."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of Mumbai’s most revered temples, dedicated to Lord Ganesha. Devotees from across the country visit for blessings, especially on Tuesdays. The temple's architecture, gold-plated dome, and peaceful ambiance make it spiritually significant."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built on an islet off the coast, this Indo-Islamic shrine houses the tomb of Sufi saint Pir Haji Ali Shah Bukhari. It is accessible via a narrow causeway during low tide and offers a unique blend of spirituality and sea views."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of the oldest flea markets in India, Chor Bazaar is famous for antiques, vintage goods, Bollywood posters, and secondhand treasures. It offers a fascinating look into Mumbai’s historic trade culture."
  },
  {
    "title": "Juhu Beach",
    "description": "A popular beach in the suburbs of Mumbai, known for its street food stalls, leisure crowd, and celebrity sightings. Visitors enjoy pav bhaji, ice gola, and walks along the shoreline, especially during the evenings."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Located in Borivali, this massive national park offers a green escape with hiking trails, lion and tiger safaris, and the historic Kanheri Buddhist caves carved into basalt rock. It’s a blend of nature, history, and recreation."
  }
],

"services": [
    {
        "name": "Book Pune to Mumbai Taxi Online",
        "description": "Easily book your Pune to Mumbai taxi online with Meghana Cab for a hassle-free travel experience. Our reliable service offers both one-way and round-trip options, ensuring flexibility for all your travel needs. Travel comfortably in our well-maintained vehicles with professional chauffeurs who prioritize your safety and convenience."
    },
    {
        "name": "One Way Taxi Service Pune to Mumbai",
        "description": "Plan a smooth and stress-free journey from Pune to Mumbai with Meghana Cab's one-way taxi service. Whether you're traveling for business, leisure, or urgent needs, our punctual drivers and comfortable cars guarantee a pleasant ride. Enjoy competitive pricing with no hidden charges and easy online booking."
    },
    {
        "name": "Round Trip Cab Pune to Mumbai",
        "description": "Opt for Meghana Cab's round trip taxi service between Pune and Mumbai for your corporate events, family outings, or weekend trips. Our round-trip packages are designed for convenience and affordability, with flexible scheduling and experienced chauffeurs to make your journey seamless and enjoyable."
    },
    {
        "name": "AC Taxi Pune to Mumbai Highway",
        "description": "Beat the heat on your Pune to Mumbai highway ride with Meghana Cab's air-conditioned taxis. Our fleet includes sedans and SUVs equipped with modern amenities for your comfort. Travel in a cool and relaxing environment, perfect for both short and long-distance trips."
    },
    {
        "name": "Outstation Taxi Pune to Mumbai",
        "description": "For your outstation travel needs from Pune to Mumbai, Meghana Cab provides dependable and comfortable taxi services. Our vehicles are ideal for family trips, business tours, or weekend getaways, featuring clean interiors, professional drivers, and timely pickups."
    },
    {
        "name": "Budget Taxi Pune to Mumbai",
        "description": "Looking for an affordable taxi from Pune to Mumbai without compromising on comfort? Meghana Cab offers budget-friendly options tailored to your travel plans. Enjoy reliable service, transparent pricing, and hassle-free booking, making your travel economical and convenient."
    },
    {
        "name": "Online Cab Booking Pune to Mumbai",
        "description": "Book your Pune to Mumbai cab instantly through Meghana Cab's online platform. Our easy-to-use booking system allows you to choose vehicle types, schedule pickups, and pay securely, ensuring a seamless and convenient experience from start to finish."
    },
    {
        "name": "Private Car Hire Pune to Mumbai",
        "description": "Hire a private car from Pune to Mumbai with Meghana Cab for personalized travel. Whether it’s a solo trip or a group journey, enjoy privacy, flexible schedules, and door-to-door service. Our private car hire ensures maximum comfort and discretion."
    },
    {
        "name": "Pune to Mumbai SUV Taxi",
        "description": "Travel comfortably with Meghana Cab’s SUV taxis from Pune to Mumbai. Perfect for larger groups or those seeking extra space, our SUVs provide ample legroom, luggage capacity, and premium comfort, making your trip enjoyable and spacious."
    },
    {
        "name": "Sedan Taxi Pune to Mumbai Trip",
        "description": "Experience smooth and elegant travel with our sedan taxis from Pune to Mumbai. Ideal for business travelers and small groups, our sedans offer a refined ride with professional chauffeurs and on-time service for a stress-free journey."
    },
    {
        "name": "Pune to Mumbai Executive Taxi",
        "description": "For executives and VIP travelers, Meghana Cab offers premium executive taxi services from Pune to Mumbai. Enjoy luxury vehicles, professional chauffeurs, and personalized services tailored to meet your high standards and busy schedule."
    },
    {
        "name": "Reliable Drivers Pune to Mumbai Taxi",
        "description": "At Meghana Cab, we pride ourselves on employing reliable and experienced drivers for Pune to Mumbai trips. Our drivers are trained for safety, punctuality, and courteous service, ensuring you reach your destination comfortably and on time."
    },
    {
        "name": "Pune to Mumbai Night Taxi",
        "description": "Travel late or overnight with Meghana Cab’s night taxi service from Pune to Mumbai. Our 24/7 availability ensures you have safe and comfortable rides at any hour, complete with well-lit vehicles and alert drivers for your peace of mind."
    },
    {
        "name": "24/7 Taxi Booking Pune to Mumbai",
        "description": "Book your Pune to Mumbai taxi anytime with Meghana Cab’s 24/7 online booking service. Whether it’s an early morning flight or a late-night arrival, our team is always ready to provide prompt and reliable taxi services to suit your schedule."
    },
    {
        "name": "Corporate Taxi Hire Pune to Mumbai",
        "description": "Meghana Cab specializes in corporate taxi hire from Pune to Mumbai, offering professional transport solutions for business meetings, conferences, and events. Benefit from customized billing, priority service, and executive vehicles to keep your corporate travel smooth and efficient."
    }
],

"tableData": [
    ["Book Pune to Mumbai Taxi Online", "One Way Taxi Service Pune to Mumbai"],
    ["Round Trip Cab Pune to Mumbai", "AC Taxi Pune to Mumbai Highway"],
    ["Outstation Taxi Pune to Mumbai", "Budget Taxi Pune to Mumbai"],
    ["Online Cab Booking Pune to Mumbai", "Private Car Hire Pune to Mumbai"],
    ["Pune to Mumbai SUV Taxi", "Sedan Taxi Pune to Mumbai Trip"],
    ["Pune to Mumbai Executive Taxi", "Reliable Drivers Pune to Mumbai Taxi"],
    ["Pune to Mumbai Night Taxi", "24/7 Taxi Booking Pune to Mumbai"],
    ["Corporate Taxi Hire Pune to Mumbai", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Trusted Pune to Mumbai Taxi Service",
        "WhyChoosedescription": "Meghana Cab provides a reliable and safe taxi service from Pune to Mumbai, ensuring that you experience a comfortable and stress-free journey whether you're traveling for business or leisure. Our focus is on customer satisfaction and timely arrivals."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mumbai Routes",
        "WhyChoosedescription": "Our professional drivers have extensive knowledge of the Mumbai-Pune Expressway and city traffic patterns. They use the best routes to avoid delays and ensure you reach your destination promptly and safely."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicle Options to Suit Your Needs",
        "WhyChoosedescription": "Whether you’re traveling solo, with family, or in a group, Meghana Cab offers a variety of vehicles including sedans, SUVs, and luxury cars. Each vehicle is well-maintained, clean, and equipped with modern amenities to make your ride enjoyable."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing Without Hidden Charges",
        "WhyChoosedescription": "We offer competitive rates with a clear fare structure for Pune to Mumbai taxi services. Our pricing is upfront, with no hidden fees, so you can plan your trip budget with confidence and peace of mind."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
        "WhyChoosedescription": "All our taxis are regularly serviced and sanitized to maintain high standards of cleanliness and comfort. Enjoy air-conditioned rides with ample legroom and luggage space, ensuring a pleasant journey no matter the distance."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
        "WhyChoosedescription": "Meghana Cab operates round-the-clock, allowing you to book a Pune to Mumbai taxi anytime—early morning, late night, or during peak hours. We cater to your schedule, offering flexibility and convenience."
    },
    {
        "WhyChooseheading": "Easy and Convenient Booking Options",
        "WhyChoosedescription": "Booking your Pune to Mumbai taxi is quick and hassle-free via our website, mobile app, or by calling our friendly customer support team. Receive instant confirmations and real-time updates for a seamless experience."
    },
    {
        "WhyChooseheading": "Safety and Customer Support You Can Rely On",
        "WhyChoosedescription": "Your safety is our top priority. Meghana Cab ensures all drivers follow safety protocols, and vehicles are equipped with GPS tracking. Our customer support team is available 24/7 to assist with any queries or emergencies during your trip."
    }
]



































    }

const faqData = [
    {
        question: "How can I book a taxi from Pune to Mumbai with Meghana Cab?",
        answer: "You can book a Pune to Mumbai taxi by calling Meghana Cab at +91 9075462128 or using our website for easy online booking."
    },
    {
        question: "What types of taxis are available for Pune to Mumbai trips?",
        answer: "We offer sedans, SUVs, and tempo travellers to suit your travel needs and group size."
    },
    {
        question: "Are Meghana Cab drivers experienced for Pune to Mumbai routes?",
        answer: "Yes, our drivers are familiar with the best routes between Pune and Mumbai to ensure a safe and timely journey."
    },
    {
        question: "Can I book a one-way or round-trip taxi from Pune to Mumbai?",
        answer: "Yes, both one-way and round-trip taxi services are available according to your preference."
    },
    {
        question: "What is included in the Pune to Mumbai taxi fare?",
        answer: "The fare covers driver charges, fuel, and vehicle maintenance. Additional charges such as tolls and parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Mumbai taxi bookings?",
        answer: "Yes, our services are available round-the-clock to accommodate your travel schedule."
    },
    {
        question: "Can I book a taxi for a large group from Pune to Mumbai?",
        answer: "Yes, we provide tempo travellers and SUVs for larger groups."
    },
    {
        question: "Are the taxis sanitized and safe for travel?",
        answer: "All our vehicles are regularly cleaned and sanitized for your safety and comfort."
    },
    {
        question: "What payment methods are accepted for Pune to Mumbai taxi bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Mumbai taxi services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Mumbai taxi services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Akshay Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab provided excellent Pune to Mumbai taxi service. The driver was punctual and the vehicle comfortable.”',
    },
    {
        name: 'Ms. Sneha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and comfortable taxi service from Pune to Mumbai by Meghana Cab. Highly recommended!”',
    },
];






























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Taxi",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-taxi.jpg",
  "description": "Book Pune to Mumbai taxi online with Meghana Cabs for fast, safe, and comfortable travel. Choose from one-way, round-trip, AC sedans, SUVs, or corporate taxis with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5532"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-taxi"
  }
};






    return (
        <div>
<Helmet>
  <title>Pune to Mumbai Taxi | Online Booking & Affordable Travel | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai taxi online with Meghana Cabs for fast, safe, and comfortable travel. Choose from one-way, round-trip, AC sedans, SUVs, or corporate taxis with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Book Pune to Mumbai Taxi Online, One Way Taxi Service Pune to Mumbai, Round Trip Cab Pune to Mumbai, AC Taxi Pune to Mumbai Highway, Outstation Taxi Pune to Mumbai, Budget Taxi Pune to Mumbai, Online Cab Booking Pune to Mumbai, Private Car Hire Pune to Mumbai, Pune to Mumbai SUV Taxi, Sedan Taxi Pune to Mumbai Trip, Pune to Mumbai Executive Taxi, Reliable Drivers Pune to Mumbai Taxi, Pune to Mumbai Night Taxi, 24/7 Taxi Booking Pune to Mumbai, Corporate Taxi Hire Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaitaxi;